import React, { useCallback } from 'react'
import { useAppDispatch } from 'hooks/reduxHooks'
import { userCartItemUndo } from 'actions/AuthActions'
import styled from 'styled-components'
import TextButton from 'LuxKit/Button/TextButton'
import LineHistoryIcon from 'LuxKit/Icons/line/LineHistoryIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import * as Analytics from 'analytics/analytics'

const DeletedTileContainer = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: ${rem(12)};
  padding: ${rem(20)};
  border-radius: ${props => props.theme.borderRadius.S};
  background: ${props => props.theme.palette.neutral.default.seven};

  ${mediaQueryUp.tablet} {
    border: 1px solid ${props => props.theme.palette.neutral.default.five};
  }
`

const TruncatedBodyText = styled(BodyText)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
interface Props {
  title: string
  itemIds: Array<string>
}

function DeletedCartReviewTile({ title, itemIds }: Props) {
  const dispatch = useAppDispatch()

  const handleUndo = useCallback(() => {
    Analytics.trackClientEvent({
      subject: 'undo_delete_item',
      action: 'click',
      category: 'multi_item_cart',
      type: 'interaction',
    })
    dispatch(userCartItemUndo(itemIds))
  }, [dispatch, itemIds])

  return (
    <DeletedTileContainer>
      <Group direction="vertical" gap={4}>
        <TruncatedBodyText variant="medium" weight="bold">{title}</TruncatedBodyText>
        <BodyText variant="medium" colour="neutral-two">was deleted from your cart</BodyText>
      </Group>
      <TextButton
        kind="secondary"
        size="small"
        startIcon={<LineHistoryIcon />}
        onClick={handleUndo}
      >
        Undo
      </TextButton>
    </DeletedTileContainer>
  )
}

export default DeletedCartReviewTile
